
const stateManager = require('../state/stateManager')
const stringUtil = require('../string/stringUtil')
const dateUtil = require('../dateUtil/dateUtil')
const dispatchTypes = require('../domain/constants').dispatchTypes;

const storeOpeningUtil = require('./storeOpeningUtil');

module.exports.availableDispatchTypes = function()
{
    var state = stateManager.getStore().getState();
        
    const availableDispatchTypes = state.allowedDispatchTypes.filter(dispatchTypeConfiguration => !this.isStoreClosedForDispatchType(dispatchTypeConfiguration.dispatchType));

    return availableDispatchTypes;
}

module.exports.getDefaultDispatchType = function()
{
    const availableDispatchTypes = this.availableDispatchTypes();

    if(availableDispatchTypes.length === 0)
        return "";

    return availableDispatchTypes[0].dispatchType;
}

module.exports.isStoreClosed = function ()
{
    return this.isStoreClosedForDispatchType(dispatchTypes.delivery) &&
        this.isStoreClosedForDispatchType(dispatchTypes.collection) &&
        this.isStoreClosedForDispatchType(dispatchTypes.dineIn) 
}

module.exports.isStoreClosedForDispatchType = function (dispatchType)
{
    const store = stateManager.getStore().getState().storefront;
    const activeSnoozeProperties = stateManager.getStore().getState().activeSnoozeProperties;
    const allowedDispatchTypes = stateManager.getStore().getState().allowedDispatchTypes;

    // Checking if app is snoozed for a particular dispatch type
    if(activeSnoozeProperties.some(x => (x.dispatchTypes.length == 0 || x.dispatchTypes.includes(dispatchType))))
        return true;

    if(!allowedDispatchTypes.some(x => x.dispatchType === dispatchType))
        return true;

    return storeOpeningUtil.isStoreClosed(store.businessHourOverrides, store.openingHours, dispatchType);
}